export { default as TabHeaderDetail } from './Detail.tab';
export { default as TabHeaderBuy } from './Buy.tab';
